import { j as r } from "./jsx-runtime-3tyXYecC.mjs";
import { Fragment as m, forwardRef as y } from "react";
import { m as d } from "./mobile-BpUO1OTk.mjs";
import { m as f } from "./tss-DN0acMKN.mjs";
import { M as u, d as w } from "./constants-CnFYFetN.mjs";
import { f as a } from "./index-LyFokDcn.mjs";
import { L as l } from "./link-0A1muLDU.mjs";
import { I as p } from "./BamboohrLogo115x17-IIZ1wwB2.mjs";
const j = f()(({ palette: e, breakpoints: t, mode: n }) => ({
  root: {
    borderColor: e.gray[300],
    borderTop: `1px solid ${e.gray[300]}`,
    outline: n === u.Dye ? `2px solid ${w.main}` : void 0,
    width: "100%"
  },
  guts: {
    display: "flex",
    justifyContent: "space-between",
    maxWidth: 1348,
    marginLeft: "auto",
    marginRight: "auto",
    [t.down(d)]: {
      flexDirection: "column-reverse",
      alignItems: "center"
    }
  },
  left: {
    color: e.gray[700],
    padding: "26px 0 51px 32px",
    fontSize: 13,
    fontWeight: 400,
    textAlign: "left",
    fontFamily: "Lato",
    "& a": {
      color: e.gray[700]
    },
    [t.down(d)]: {
      padding: "10px 0 51px"
    }
  },
  defaultChildren: {
    display: "flex",
    [t.down(d)]: {
      flexDirection: "column",
      alignItems: "center",
      "& div": {
        padding: "10px 0"
      },
      "& span": {
        display: "none"
      }
    }
  },
  right: {
    padding: "31px 32px 45px 0",
    [t.down(d)]: {
      padding: "31px 0 0"
    }
  }
})), s = () => /* @__PURE__ */ r.jsxs(m, { children: [
  a.ifFeature(
    "encore",
    /* @__PURE__ */ r.jsx(
      l,
      {
        href: "https://www.bamboohr.com/privacy.php?_ga=2.47001447.152851771.1626205797-455172675.1573665630",
        target: "_blank",
        children: window.jQuery ? $.__("Privacy Policy") : "Privacy Policy"
      }
    ),
    /* @__PURE__ */ r.jsx(
      "a",
      {
        href: "https://www.bamboohr.com/privacy.php?_ga=2.47001447.152851771.1626205797-455172675.1573665630",
        rel: "noopener external nofollow noreferrer",
        target: "_blank",
        children: window.jQuery ? $.__("Privacy Policy") : "Privacy Policy"
      }
    )
  ),
  "  ·  ",
  a.ifFeature(
    "encore",
    /* @__PURE__ */ r.jsx(
      l,
      {
        href: "https://www.bamboohr.com/terms.php?_ga=2.51825897.152851771.1626205797-455172675.1573665630",
        target: "_blank",
        children: "Terms of Service"
      }
    ),
    /* @__PURE__ */ r.jsx(
      "a",
      {
        href: "https://www.bamboohr.com/terms.php?_ga=2.51825897.152851771.1626205797-455172675.1573665630",
        rel: "noopener external nofollow noreferrer",
        target: "_blank",
        children: "Terms of Service"
      }
    )
  )
] }), v = () => /* @__PURE__ */ r.jsxs(m, { children: [
  "© 2008–",
  (/* @__PURE__ */ new Date()).getFullYear(),
  " BambooHR ",
  window.jQuery ? $.__("All rights reserved") : "All rights reserved",
  "."
] }), b = f()(({ palette: e }) => ({
  icon: {
    fill: e.gray[800]
  }
})), D = y(({ classes: e, children: t, right: n }, c) => {
  const { classes: h } = b(), { classes: o, cx: i } = j(), x = /* @__PURE__ */ r.jsxs("div", { className: i(o.defaultChildren, e == null ? void 0 : e.defaultChildren), children: [
    /* @__PURE__ */ r.jsx("div", { children: /* @__PURE__ */ r.jsx(s, {}) }),
    /* @__PURE__ */ r.jsx("span", { children: "  ·  " }),
    /* @__PURE__ */ r.jsx(v, {})
  ] }), g = /* @__PURE__ */ r.jsx("div", { className: h.icon, children: /* @__PURE__ */ r.jsx(p, {}) });
  return /* @__PURE__ */ r.jsx("div", { className: i(o.root, e == null ? void 0 : e.root), "data-fabric-component": "Footer", ref: c, role: "contentinfo", children: /* @__PURE__ */ r.jsxs("div", { className: i(o.guts, e == null ? void 0 : e.guts), children: [
    /* @__PURE__ */ r.jsx("div", { className: i(o.left, e == null ? void 0 : e.left), children: typeof t > "u" || t === "" ? x : t }),
    /* @__PURE__ */ r.jsx("div", { className: i(o.right, e == null ? void 0 : e.right), children: typeof n > "u" || n === "" ? g : n })
  ] }) });
});
export {
  D as F
};
//# sourceMappingURL=footer-BVvgFEou.mjs.map
